export default {
  title: 'Configuración',
  fields: {
    discount_type: {
      label: 'Tipo de descuento',
    },
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    update_successful: 'Actualizado correctamente',
    updated_failed: 'Error al actualizar',
  },
};
